import { DataGrid } from '@mui/x-data-grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid/locales';
import * as React from 'react';
import Box from '@mui/system/Box';


export default function OraxTable({rotulo,tamañoLetra,rows,columns})
{
    const idioma = createTheme(esES,);

    const estiloLabel = {
        width:window.innerWidth,
        textAlign:'center',
        fontSize: '2em',
        display: 'block',
        color:(localStorage.getItem('estilo') === 'Green')?'black':'white'
    }

    return (
        <Box >
            <label style={estiloLabel}>{rotulo}</label>
            <ThemeProvider theme={idioma}>
                <DataGrid
                    sx={{
                        '.MuiDataGrid-row': {
                            fontSize: tamañoLetra,
                        }
                    }}
                    rows={rows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 5 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                            ? (localStorage.getItem('estilo') === 'Green')?'FilasParesUsuariosGreen':'FilasParesUsuariosDark'
                            : (localStorage.getItem('estilo') === 'Green')?'FilasNonesUsuariosGreen':'FilasNonesUsuariosDark'
                    }
                ></DataGrid>
            </ThemeProvider>
        </Box>
    );
}